/**
 * Copyright (c) [2015-2019] SUSE Linux
 *
 * This software may be modified and distributed under the terms
 * of the MIT license.  See the LICENSE.txt file for details.
 */

/**
 * This module offers an API to interact with a Janus server.
 *
 * @todo Read configuration.
 */
import { createRoomService } from './room-service';
import { createFeedsService } from './feeds-service';
import { createEventsService } from './events-service';
import { createDataChannelService } from './data-channel-service';
import { createActionService } from './action-service';
import { createCallService } from './call-service';

export default (function() {
  let that = {
    dataChannelService: null,
    eventsService: null,
    feedsService: null,
    roomService: null,
    actionService: null,
    callService: null
  };

  that.setup = function(
    { janusServer, janusDebug, janusWithCredentials, joinUnmutedLimit, videoThumbnails },
    handler
  ) {
    that.eventsService = createEventsService();
    that.feedsService = createFeedsService(that.eventsService);
    that.dataChannelService = createDataChannelService(
      that.feedsService,
      that.eventsService
    );

    that.actionService = createActionService(
      that.feedsService,
      that.dataChannelService,
      that.eventsService
    );

    that.roomService = createRoomService(
      { janusServer, janusDebug, janusWithCredentials, joinUnmutedLimit, videoThumbnails },
      that.feedsService,
      that.dataChannelService,
      that.eventsService,
      that.actionService
    );

    // 初始化通话服务
    that.callService = createCallService(
      { janusServer, janusDebug, janusWithCredentials },
      that.eventsService,
      that.dataChannelService
    );

    // 监听通话信令事件
    that.eventsService.getRoomSubject().subscribe(event => {
      console.log("收到信令事件callService1: ");
      console.log(event);
      console.log("收到信令事件callService2: ");
      if (event.type === 'callSignal') {
        that.callService.handleCallSignal(event.content);
      }
    });

    if (handler) {
      that.getRoomSubject().subscribe(handler);
    }
  };

  // create rooom
  that.createRoom = (params) => {
    return that.roomService.createRoom(params);
  };
  // destroyed rooom
  that.destroyedRoom = (params) => {
    return that.roomService.destroyedRoom(params);
  };

  that.getRooms = () => that.roomService.getRooms();
  that.enterRoom = (room, username, pin) => {
    that.roomService.setRoom(room);
    return that.roomService.enter(username, pin);
  };
  that.publishScreen = () => that.roomService.publishScreen('screen');
  that.unpublishFeed = (feedId) => that.roomService.unPublishFeed(feedId);
  that.leaveRoom = () => that.roomService.leave();
  that.getRoomSubject = () => that.eventsService.getRoomSubject();
  that.sendMessage = (text) => that.actionService.writeChatMessage(text);

  //record
  that.record = (mixStreams, callId, roomId) => {
    return that.roomService.record(mixStreams, callId, roomId);
  }
  // change record stracks
  that.changeTracks = (tracks) => {
    return that.roomService.changeTracks(tracks);
  }
  // stopRecord
  that.recordStop = () => {
    return that.roomService.recordStop();
  }
  //play record
  that.play = (id) => {
    return that.roomService.play(id);
  }
  //play record stop
  that.stopPlay = () => {
    return that.roomService.stopPlay();
  }

  that.toggleAudio = (feedId) => {
    let feed = that.feedsService.find(feedId);
    if (!feed) return;

    that.roomService.toggleChannel('audio', feed);
  };
  that.toggleVideo = () => {
    that.roomService.toggleChannel('video');
  };
  that.reconnectFeed = (feedId) => that.roomService.reconnectFeed(feedId);

  // 通话服务公共API
  that.initiateCall = (remoteUserId, username, callId) =>
    that.callService.initiateCall(remoteUserId, username, callId);
  
  that.acceptCall = (callId, username) =>
    that.callService.acceptCall(callId, username);
  
  that.rejectCall = (callId, reason) =>
    that.callService.rejectCall(callId, reason);
  
  that.endCall = (callId) =>
    that.callService.endCall(callId);
  
  that.getCurrentCall = () =>
    that.callService.getCurrentCall();
  
  that.isInCall = () =>
    that.callService.isInCall();
  
  // 处理通话信令的辅助方法
  that.handleCallSignal = (signalData) =>
    that.callService.handleCallSignal(signalData);

  return that;
})();
